<script setup lang="ts">
    import CollapsibleSection from "@/components/generic/CollapsibleSection.vue";
    import MaterialRow from "@/tabs/Admin/ListMaterialgrupp/MaterialRow.vue";
    import { toRefs } from "vue";

    const props = defineProps<{
        item: {
            material: {
                antal: number;
                material: number;
            }[];
        };
    }>();

    const { item } = toRefs(props);
</script>

<template>
    <collapsible-section :heading="`${item.material.length} st`" isSingle :isExpanded="false" class="material-cell">
        <div class="content">
            <div class="header">
                <span>#</span>
                <span>Namn</span>
                <span class="artikelnummer">Artikelnummer</span>
            </div>
            <MaterialRow
                v-for="({ antal, material }, index) in item.material"
                :key="material"
                :material-id="material"
                :antal="antal"
                :index="index"
            />
        </div>
    </collapsible-section>
</template>

<style lang="scss" scoped>
    .material-cell {
        width: inherit;
        margin-bottom: 0;

        ::v-deep .header {
            width: inherit;

            h3 {
                width: inherit;
                margin-bottom: 0;
                font-size: 1rem;
                font-family: "Roboto Medium";

                .toggle {
                    width: inherit;
                    padding: 1rem 0;

                    .chevron {
                        margin-left: 0.5rem;
                    }
                }
            }
        }

        ::v-deep .content {
            margin-bottom: 1rem;
        }

        .content {
            display: grid;
            grid-template-columns: auto 1fr 1fr;
            grid-auto-flow: row;
            grid-auto-rows: auto;
            grid-gap: 0.3rem;
            height: inherit;

            .header {
                display: grid;
                grid-column: 1 / -1;
                grid-template-columns: subgrid;
                grid-auto-flow: column;
                grid-gap: 0.2rem;
                color: #277692;

                .artikelnummer {
                    margin-left: 0.5rem;
                }
            }
        }
    }
</style>
